<template>
  <div class="thousand_layout" v-loading="loading">
    <div class="bids_tabs">
      <div @click="BidsTabs(0)" :class="bidsTabs==0?'on':''">{{ $t('base.bids') }}</div>
      <div @click="BidsTabs(1)" :class="bidsTabs==1?'on':''">{{ $t('base.offers') }}</div>
      <div @click="BidsTabs(2)" :class="bidsTabs==2?'on':''">{{ $t('base.auctionEnded') }}</div>
    </div>
    <div class="right_box" v-if="bidsTabs==0">
      <div class="flex_layout_bids">
        <div class="bids_radio_box">
          <!--   Show:
          <el-radio v-model="bids" label="1">Not hidden</el-radio>
          <el-radio v-model="bids" label="2">All</el-radio> -->
        </div>
        <div class="watch_sort_status">
          <div>
            {{ $t('colon.sort') }}
            <el-select class="all_bids all_sort" v-model="Sort" @change="bidsSort">
              <el-option v-for="(item,index) in bids_sort" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="right_box" v-if="bidsTabs==1">
      <div class="flex_layout_bids">
        <div class="bids_radio_box">
          <!--   Show:
          <el-radio v-model="bids" label="1">Not hidden</el-radio>
          <el-radio v-model="bids" label="2">All</el-radio> -->
        </div>
        <div class="watch_sort_status">
          <div>
            {{ $t('colon.status') }}
            <el-select class="all_bids offer" v-model="oStatus" @change="offerStatus">
              <el-option v-for="(item,index) in offer_Status" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>
            {{ $t('colon.sort') }}
            <el-select class="all_bids all_sort" v-model="Sort" @change="bidsSort">
              <el-option v-for="(item,index) in offer_sort" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
      <watch-list class="" :list="list" :type="listType" @updatedWatch="updatedWatch" v-if="!nofind"/>
      <!-- <watch-check class="" :list="list" :type="listType" v-if="bidsTabs!=0"/> -->
      <list-pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!nofind"/>
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
      <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else/>
  </div>
</template>
<script>
import WatchList from '@/components/list/watch'
import WatchCheck from '@/components/list/watchcheck'
import ListPagination from '@/components/listpagination'
import NOTN from "@/components/notnull";
import FZF from "@/components/404.vue";

export default {
  name: 'tabslist',
  components: { WatchList, WatchCheck, ListPagination, FZF, NOTN },
  data() {
    return {
      loading:false,
      listType: "bids",
      list: "",
      pi: 1,
      ps: 60,
      TotalCount: 0,
      onsale: 1,
      isStatus: false,
      isSort: false,
      bids: '1',
      bidsTabs: 0,
      oStatus: 'null',
      Sort: "1",
      offer_Status: this.$enumInfo.offer_status,
      bids_sort: this.$enumInfo.bids_sort,
      offer_sort: this.$enumInfo.offer_sort,
      sum:'',
      nofind:false,
      resultTpye: '',
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.getBids();
  },
  mounted() {
    //this.getOffer()
  },
  methods: {
    // 获取竞拍列表
    getBids() {
      let that = this;
      that.loading=true;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, onsale:that.onsale, sortType: that.Sort, pageIndex: that.pi, pageSize: that.ps }
      this.$get(this.$interface.BuyerAuction, data).then(res => {
        if (res.result != 0) {
          console.log(res)
          that.list = JSON.parse(JSON.stringify(res.data))
          that.TotalCount = res.count
          if(res.count==0){
            this.nofind=true
          }else{
            this.nofind=false
          }
        }else{
          this.nofind=true
        }
        that.loading=false;
        this.resultTpye = res.result
      })
    },
    // 获取一口价列表
    getOffer() {
      let that = this;
      that.loading=true;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, onsale: that.onsale, status: that.oStatus, sortType: that.Sort, pageIndex: that.pi, pageSize: that.ps }
      this.$get(this.$interface.BuyerBargain, data).then(res => {
        if (res.result != 0) {
          that.list=""
          that.list = JSON.parse(JSON.stringify(res.data))
          that.TotalCount = res.count
          if(res.count==0){
            this.nofind=true
          }else{
            this.nofind=false
          }
        }else{
          this.nofind=false
        }
        that.loading=false;
        this.resultTpye = res.result
      })
    },
    BidsTabs(val) {
      this.bidsTabs = val;
      this.pi = 1;
      this.ps = 60;
      this.Sort = '1';
      this.list='';
      if (val == 0) {
        this.listType = "bids";
        this.onsale = 1;
        this.getBids();
      }
      if (val == 1) {
        this.listType = "offers";
        this.Sort = '2';
        this.getOffer()
      }
      if (val == 2) {
        this.listType = "bids";
        this.onsale = 2;
        this.Sort = '3';
        this.getBids()
      }
    },
    bidsSort() {
      if (this.listType == "bids") {
        this.getBids()
      } else if (this.listType == "offers") {
        this.getOffer()
      }
    },
    offerStatus() {
      this.getOffer()
    },
    updatedWatch(val) {
      this.getBids()
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      if(this.listType=='bids'){
        this.getBids();
      }else{
        this.getOffer()
      }
      //this.getBids();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      if(this.listType=='bids'){
        this.getBids();
      }else{
        this.getOffer()
      }
      //this.getBids();
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";
.flex_layout_bids{
    line-height: 48px;
    padding: 0;
    height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/bids.vue